/**
 * Remove unsafe characters from string
 * @function checkForUnsafeChars
 * @param {String} stringToCheck - String to check
 */

export function checkForUnsafeChars(stringToCheck) {
  if (stringToCheck.match(/^[a-zA-Z0-9_-]*$/)) {
    return true;
  } else {
    return false;
  }
}
